let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bV9I0")).then(() => parcelRequire('fROot'));